import { ConfigProvider, Modal } from 'antd'
import React from 'react'

import type { ModalProps } from 'antd'

import { CssIcon } from '@/components/CssIcon'

export default function TipsBaseModal(props: ModalProps) {
  const { className, wrapClassName, open, ...restProps } = props

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            padding: 0,
          },
        },
      }}
    >
      <Modal
        width={560}
        footer={null}
        maskClosable={false}
        centered
        className={tw`
          text-f-text [&_[class=coco-modal-close]]:right-1 [&_[class=coco-modal-close]]:top-1 ${className}
        `}
        wrapClassName={tw`
          [&_.coco-modal-content]:border-f-border-active
          [&_.coco-modal-close-x]:size-full
          [&_.coco-modal-close]:size-6
          [&_.coco-modal-content]:border
          [&_.coco-modal-content]:border-solid
          ${wrapClassName}
        `}
        closeIcon={
          <CssIcon
            containerClassName='h-full relative z-[2] w-full max-w-5 min-h-5'
            className='i-com--x text-f-text-quaternary  size-full'
          />
        }
        open={open}
        {...restProps}
      />
    </ConfigProvider>
  )
}
